import { AotCategoryType } from '../utils/Constants';
import Utils from '../utils/Utils';
import { Event } from './Events/Event';
import ctxsNative from './ctxsNative';
import NativeBridgeWrapper from './dsAuth/NativeBridgeWrapper';
import { ProtectionMode, SsoCredentialType } from './dsAuth/data/AuthTypes';
import {
	CryptoParams,
	GetSsoCredentialsParams,
	IsIWAEnabledParams,
	IsIWAEnabledResponse,
	WriteTraceParams,
} from './main';
interface Environment {
	sendEventToNative<T>(event: Event<T>): void;
	encrypt(
		referenceUri: string,
		token: string,
		protectMode?: ProtectionMode
	): Promise<string>;
	decrypt(
		referenceUri: string,
		token: string,
		protectMode?: ProtectionMode
	): Promise<string>;
	isIWAEnabled(storeUrl: string): Promise<boolean>;
	deleteWebViewCookies(): Promise<void>;
	getSessionCookieComplete(id: string, response: string): Promise<void>;
	getTranslatedUrlComplete(id: string, response: string): Promise<void>;
	writeAmlTrace(trace: string, level?: string, aotCategory?: AotCategoryType): void;
	getSsoCredentials(credentialType: SsoCredentialType): Promise<string>;
}

const environment: Environment = {
	sendEventToNative(event) {
		if (
			Utils.getInstance().isBridgeFunctionSupported(ctxsNative, 'dispatchEventToNative')
		) {
			ctxsNative.dispatchEventToNative(JSON.stringify(event));
		}
	},

	async encrypt(
		referenceUri: string,
		token: string,
		protectMode?: ProtectionMode
	): Promise<string> {
		let encryptedToken;
		if (Utils.getInstance().isBridgeFunctionSupported(ctxsNative, 'EncryptV2')) {
			const params: CryptoParams = {
				referenceUri: referenceUri,
				token: token,
				protectionMode: protectMode,
			};
			encryptedToken = await ctxsNative.EncryptV2(JSON.stringify(params));
		} else {
			encryptedToken = await ctxsNative.Encrypt(referenceUri, token);
		}
		return encryptedToken;
	},

	async decrypt(
		referenceUri: string,
		token: string,
		protectMode?: ProtectionMode
	): Promise<string> {
		let decryptedToken;
		if (Utils.getInstance().isBridgeFunctionSupported(ctxsNative, 'DecryptV2')) {
			const params: CryptoParams = {
				referenceUri: referenceUri,
				token: token,
				protectionMode: protectMode,
			};
			decryptedToken = await ctxsNative.DecryptV2(JSON.stringify(params));
		} else {
			decryptedToken = await ctxsNative.Decrypt(referenceUri, token);
		}
		return decryptedToken;
	},

	async deleteWebViewCookies() {
		await ctxsNative.DeleteWebViewCookies();
	},

	async getSessionCookieComplete(id: string, response: string): Promise<void> {
		await ctxsNative.getSessionCookieComplete(id, response);
	},

	async getTranslatedUrlComplete(id: string, response: string): Promise<void> {
		await ctxsNative.getTranslatedUrlComplete(id, response);
	},

	async isIWAEnabled(storeUrl: string): Promise<boolean> {
		if (Utils.getInstance().isBridgeFunctionSupported(ctxsNative, 'isIWAEnabled')) {
			const params: IsIWAEnabledParams = {
				storeUrl,
			};
			const resp = await NativeBridgeWrapper.isIWAEnabled(JSON.stringify(params));
			const respObject: IsIWAEnabledResponse = JSON.parse(resp);
			return respObject.response;
		} else {
			return false;
		}
	},

	writeAmlTrace(trace: string, level?: string, aotCategory?: AotCategoryType) {
		const params: WriteTraceParams = {
			trace,
			level,
			aotCategory,
		};
		ctxsNative.WriteAMLTrace(JSON.stringify(params));
	},

	async getSsoCredentials(credentialsType: SsoCredentialType): Promise<string> {
		if (Utils.getInstance().isBridgeFunctionSupported(ctxsNative, 'getSsoCredentials')) {
			const params: GetSsoCredentialsParams = {
				credentialsType,
			};
			return await NativeBridgeWrapper.getSsoCredentials(JSON.stringify(params));
		} else {
			return null;
		}
	},
};
export { environment };
